import React from 'react'

import FAIcon from '../components/FAIcon'

import Select from './controls/Select'

const TransportationServiceSelecter = ({
  onChange,
  name,
  value,
  services,
  onAddRequested,
  onEditRequested,
  ...props
}) => {
  const options = services.map(x => ({ value: x.id, label: x.name }))
  const selectedValue = options.find(x => x.value === value)
  const safeValue = selectedValue || null

  return (
    <div>
      <div className="d-inline-block col-10 px-0">
        <Select
          {...props}
          name={name}
          id={name}
          value={safeValue}
          placeholder="Search transportation services"
          options={options}
          onChange={onChange}
          footerText={onAddRequested ? '+ Add new transportation service...' : null}
          onFooterClick={onAddRequested}
          noOptionsMessage={() => 'No results found'}
        />
      </div>
      <button
        type="button"
        className="fa-button"
        onClick={() => {
          if (onEditRequested && selectedValue) {
            onEditRequested(selectedValue.value)
          }
        }}
        disabled={!selectedValue}
      >
        <FAIcon
          type="fas"
          name="pen"
          className={`d-inline-block col-2 ${!selectedValue ? 'text-muted' : 'text-primary'}`}
        />
      </button>
    </div>
  )
}

export default TransportationServiceSelecter
